import gql from "graphql-tag";

export const STAR_REPOSITORY = gql`
  mutation($id: ID!) {
    addStar(input: { starrableId: $id }) {
      starrable {
        id
        viewerHasStarred
             stargazers{
            totalCount
            }
      }
    }
  }
`;
